<template>
    <div id="Index">
        <!--头部文件-->
        <header>
            <div class="header-logo">
                <img src="../assets/img/logo.png" alt="">
                <select @change="changeCity" v-model="cityObject" v-show="selectShow">
                    <option
                        v-for="(item, index) of cityArr"
                        :value="item"
                        :key="index"
                    >{{item.deptName}}
                    </option>
                </select>
            </div>
            <div class="header-login">
                <!--<div class="search">-->
                <!--    <input type="text" placeholder="搜索一下">-->
                <!--    <img src="../assets/img/搜索.png" alt="">-->
                <!--</div>-->
                <div class="header-login-content" v-show="!user">
                    <span @click="toLogin">登录</span>
                    <span>|</span>
                    <span @click="register">注册</span>
                </div>
                <div class="user" v-show="user">
                    <el-popover
                        placement="bottom"
                        width="150"
                        trigger="hover">
                        <div id="user-info-link" class="user-info-link">
                            <router-link :to="{path: '/UserInfo'}">个人信息</router-link>
                            <router-link :to="{path: '/InfoRelease'}">个人发帖</router-link>
                            <router-link :to="{path: '/MyPost'}">我的帖子</router-link>
                            <router-link :to="{path: '/Enterprise'}" v-if="auditStatus === '0' || auditStatus === '99'">成为企业用户</router-link>
                            <div class='status-btn' v-if="auditStatus!=='0' && auditStatus !== '10' && auditStatus!=='999'" @click="dialogVisible=true">企业申请状态</div>
                            <router-link to="/" @click.native.stop="toManage" v-if="auditStatus === '10'">企业用户管理</router-link>
                            <router-link to="/" @click.native="logout">退出</router-link>
                        </div>
                        <div class="header-box" slot="reference">
                            <img
                                :src="user.avatar ? user.avatar : $common.BASE_URL + '/img/profile.jpg'"
                                alt="">
                        </div>
                    </el-popover>
                </div>
            </div>
        </header>
        <nav class="nav">
            <div class="nav-box">
                <div class="nav-item" :class="{'nav-active':index == curIndex}" v-for="(item, index) of navList" :key="index" @click="navTo(item,index)">
                    {{item.name}}
                </div>
            </div>
        </nav>
        <router-view/>
        <footer>
            <div class="footer-box">
                <div class="friendship">
                    <div v-for="(item, index) of footerList" :key="index">
                        {{item.name}}
                        <span>|</span>
                    </div>
                </div>
                <p>Copyright @ 2020 . All rights reserved.</p>
                <p><a href="https://beian.miit.gov.cn" style="color:#999">浙ICP备2021014485号</a> 易海钓科技</p>
            </div>
        </footer>
        <Modal :show="registerShow" @close="close">
            <div class="register-content" slot="modal-content">
                <p>欢迎加入海钓公园</p>
                <div :class="index === registerInputList.length -1 ? 'code-input' : 'input'"
                     v-for="(input, index) of registerInputList"
                     :key="index">
                    <input type="text" :placeholder="input.placeholder" v-model="registerData[input.name]">
                    <span v-show="index === registerInputList.length -1" class="code" @click="getCode">|&nbsp;&nbsp;{{ableGetCode ? '获取验证码' : `${time}后重新获得验证码`}}</span>
                </div>
                <div class="button" @click="registerSubmit">注册</div>
                <div class="tip">
                    <!--<div>企业注册</div>-->
                    已有账号? <span @click="toLogin">去登录</span>
                </div>
            </div>
        </Modal>
        <Modal :show="loginShow" @close="close">
            <div class="register-content login-content" slot="modal-content">
                <p>用户登录</p>
                <div class="input"
                     v-for="(input, index) of loginInputList"
                     :key="index">
                    <input :type="input.type || 'text'" :placeholder="input.placeholder"
                           v-model="loginData[input.name]">
                </div>
                <div class="button" @click="loginSubmit">登录</div>
                <div class="tip"><span @click="register">注册</span></div>
            </div>
        </Modal>
        <el-dialog
            :visible.sync="dialogVisible"
            width="800"
            >
            <div slot="title" class="dialog-title">
               审核状态  ---  <span>{{ auditStatusText }}</span>
            </div>
            <el-form ref="form" :model="form" label-width="100px" size="medium">
                <div
                    class="register-item"
                    v-for="(item, index) of inputList"
                    :key="index"
                >
                <template v-if="auditStatus!=='9' && item.model==='opinion'">
                    <el-form-item :label="item.name"  >
                    <el-input v-if="item.type === 'textarea'" disabled :type="item.type" v-model="form[item.model]"></el-input>
                </el-form-item>
                </template>
                <template  v-if="item.model!=='opinion'">
                    <el-form-item :label="item.name">
                        <el-input
                            :placeholder="item.placeholder"
                            v-if="item.type === 'input'"
                            v-model="form[item.model]"
                            disabled
                        >
                        </el-input>
                        <img v-else-if="item.type ==='upload'" class="busi_cert" :src="form[item.model]">
                    </el-form-item>
                 </template>
                </div>
            </el-form>
            <!-- <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </div> -->
        </el-dialog>
    </div>
</template>

<script>
    import Modal from '../components/modal/Modal'
    import eventBus from '../assets/js/event_bus'
    import {mapGetters} from 'vuex'

    export default {
        name: 'Index',
        components: {Modal},
        data() {
            return {
                curIndex: 0,
                areaList: ['青岛', '济南'],
                recommendList: [
                    {
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题,舟山海钓是旅游的一种方式',
                        img: require('../assets/img/pic4.png')
                    },
                    {
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题,舟山海钓是旅游的一种方式',
                        img: require('../assets/img/pic5.png')
                    },
                    {
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题,舟山海钓是旅游的一种方式',
                        img: require('../assets/img/pic6.png')
                    }
                ],
                commodityList: [
                    {
                        banner: require('../assets/img/pic1.png'),
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题',
                        value: '¥290'
                    },
                    {
                        banner: require('../assets/img/pic2.png'),
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题',
                        value: '¥290'
                    },
                    {
                        banner: require('../assets/img/pic3.png'),
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题',
                        value: '¥290'
                    }
                ],
                testList: [
                    {
                        banner: require(`../assets/img/pic1.png`),
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题',
                        subtitle: '舟山海岛海洋资源丰富，有着发展旅游的得天独厚条件。 2016年11月，舟山被国家旅游局列为国家全域旅游示范区创建单位，提出“全景舟山”建设目标，全面推进海岛城乡景区化建设。',
                        time: '2020-2-24'
                    },
                    {
                        banner: require(`../assets/img/pic3.png`),
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题',
                        subtitle: '舟山海岛海洋资源丰富，有着发展旅游的得天独厚条件。 2016年11月，舟山被国家旅游局列为国家全域旅游示范区创建单位，提出“全景舟山”建设目标，全面推进海岛城乡景区化建设。',
                        time: '2020-2-24'
                    },
                    {
                        banner: require(`../assets/img/pic2.png`),
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题',
                        subtitle: '舟山海岛海洋资源丰富，有着发展旅游的得天独厚条件。 2016年11月，舟山被国家旅游局列为国家全域旅游示范区创建单位，提出“全景舟山”建设目标，全面推进海岛城乡景区化建设。',
                        time: '2020-2-24'
                    }
                ],
                xuanBtn: [
                    {name: '海钓资讯'},
                    {name: '比赛信息'},
                    {name: '海钓常识'}
                ],
                fuBtn: {
                    海钓公司: [
                        {name: '运营资质'},
                        {name: '违法处理'},
                        {name: '保险投保'},
                        {name: '金融贷款'}
                    ],
                    游客: [
                        {name: '海钓证申请'},
                        {name: '一键救援'},
                        {name: '投诉举报'},
                        {name: '人工咨询'},
                        {name: '酒店预约'}
                    ]
                },
                footerList: [
                    {name: '友情链接'},
                    {name: '友情链接'},
                    {name: '友情链接'},
                    {name: '友情链接'},
                    {name: '友情链接'}
                ],
                navList: [
                    {name: '首页', path: '/'},
                    {name: '海钓资讯', path: '/FishInfo?type=1'},
                    {name: '海钓活动', path: '/FishInfo?type=2'},
                    {name: '海钓常识', path: '/FishInfo?type=3'},
                    {name: '热门信息', path: '/FishInfo?type=4'},
                    {name: '海钓视频', path: '/Strategy?type=1'},
                    // {name: '钓场信息', path: '/OffshoreInfo'},
                    {name: '海钓渔获', path: '/Strategy?type=8'}
                    // {name: '海钓论坛', path: '/Strategy?type=9'}
                ],
                // 注册现实
                registerShow: false,
                loginShow: false,
                registerInputList: [
                    {name: 'phone', placeholder: '请输入手机号'},
                    {name: 'password', placeholder: '请输入密码'},
                    {name: 'passwordConfirm', placeholder: '请确认密码'},
                    {name: 'nickName', placeholder: '请输入昵称'},
                    {name: 'dxyzm', placeholder: '请输入验证码', codeConfirm: true}
                ],
                loginInputList: [
                    {name: 'phone', placeholder: '请输入手机号'},
                    {name: 'password', placeholder: '请输入密码', type: 'password'}
                ],
                registerData: {
                    phone: '',
                    password: '',
                    passwordConfirm: '',
                    nickName: '',
                    dxyzm: ''
                },
                loginData: {
                    phone: '',
                    password: ''
                },
                cityObject: '',
                selectShow: true,
                ableGetCode: true,
                time: 60,
                // 企业审核状态 默认为 999
                auditStatus: '999',
                // 是否显示审核弹框
                dialogVisible: false,
                form: {},
                inputList: [
                    { name: '审核意见', type: 'textarea', model: 'opinion' },
                    { name: '企业名称', type: 'input', model: 'bName' },
                    { name: '企业性质', type: 'input', model: 'bProperties' },
                    { name: '企业地址', type: 'input', model: 'bAddress' },
                    { name: '法人姓名', type: 'input', model: 'legalPerson' },
                    { name: '法人身份证', type: 'input', model: 'idcard' },
                    { name: '所属辖区', type: 'input', model: 'jurisdiction' },
                    { name: '船舶数量', type: 'input', model: 'ships' },
                    { name: '驾驶员数量', type: 'input', model: 'drivers' },
                    { name: '主营业务', type: 'input', model: 'qualification' },
                    { name: '联系方式', type: 'input', model: 'contact' },
                    { name: '营业执照', type: 'upload', model: 'busiCert' }
                 ]
            }
        },
        methods: {
            /**
             * 切换tab
             */
            changeTab(item) {
                console.log(item)
            },
            /**
             * 切换城市
             */
            changeCity() {
                this.$store.commit('setCity', this.cityObject)
                eventBus.$emit('changeCity', this.cityObject)
            },
            /**
             * 跳转
             */
            navTo(item, idx) {
                this.curIndex = idx
                // console.log(item)
                this.$router.push(item.path)
            },
            /**
             * 注册
             */
            register() {
                this.loginShow = false
                this.registerShow = true
            },
            /**
             * 关闭dialog
             */
            close(boolean) {
                this.registerShow = boolean
                this.loginShow = boolean
            },
            /**
             * 跳转登录
             */
            toLogin() {
                this.registerShow = false
                this.loginShow = true
            },
            /**
             * 提交后台注册数据
             */
            registerSubmit() {
                if (this.registerData.password !== this.registerData.passwordConfirm) {
                    this.$message.error('两次密码不一致')
                    return false
                }
                console.log(this.registerData)
                this.$common.querystringifyPost('/memberApp/register', this.registerData).then(res => {
                    console.log(res)
                    if (res.data.code === -1) {
                        this.$message.error(res.data.msg)
                    } else {
                        this.$message.success('注册成功')
                        this.registerShow = false
                    }
                })
            },
            /**
             * 登录按钮
             */
            loginSubmit() {
                this.$common.querystringifyPost('/memberApp/login', this.loginData).then(res => {
                    // console.log(res)
                    if (res.data.code === -1) {
                        this.$message.error(res.data.msg)
                    } else {
                        this.$message.success('登录成功')
                        this.loginShow = false
                        this.$store.commit('setToken', res.data.data.token)
                        this.$store.commit('setUser', res.data.data)
                        localStorage.setItem('phoneNumber', res.data.data.phone)
                        this.$store.dispatch('getUser')
                        this.getAuditStatus()
                    }
                })
            },
            logout() {
                this.$store.commit('logout')
                localStorage.removeItem('phoneNumber')
                this.$message.success('退出成功')
            },
            toManage() {
                window.open(`${this.$common.BASE_URL}/weblogin?webtoken=${window.localStorage.getItem('token')}`)
            },
            // 判断路由当前的位置
            routerPath() {
                if (this.$route.path === '/') {
                    this.selectShow = true
                } else {
                    this.selectShow = false
                }
            },
            // 获得手机验证码
            getCode() {
                if (!this.registerData.phone) {
                    this.$message.error('请输入验证手机号')
                    return false
                }
                if (!this.ableGetCode) {
                    this.$message.error('请等待再发送验证码')
                    return false
                }
                this.codeCountDown()
                this.$common.querystringifyPost('/memberApp/getCodeForApp', {
                    phone: this.registerData.phone
                }).then(res => {
                    if (res.data.code === -1) {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            /**
             * 添加倒计时发送验证码
             */
            codeCountDown() {
                this.ableGetCode = false
                let timer = setInterval(() => {
                    if (this.time > 0) {
                        this.time--
                    } else {
                        clearTimeout(timer)
                        this.time = 60
                        this.ableGetCode = true
                    }
                }, 1000)
            },
             // 获取企业审核状态
            getAuditStatus() {
                let phoneNumber = localStorage.getItem('phoneNumber')
                let token = localStorage.getItem('token')
                if (!token) {
                    return
                }
                let params = {
                    phoneNumber: phoneNumber
                }
                this.$common.queryAnyAddrPost(this.$common.BASE_URL_COM + '/hdplatform/app/getBussinessStatusInfo', params).then(res => {
                    this.dealAuditStatus(res.data)
                })
            },
            dealAuditStatus(data) {
                if (!data.hasOwnProperty('total')) {
                    return
                }
                let status = '0'
                let form = {} // 审核信息赋值
                let auditInfo = data.rows[0]
                if (data.total === 0) {
                    status = '0'
                } else {
                    status = auditInfo.status
                    for (let i in auditInfo) {
                        form[i] = auditInfo[i]
                    }
                    if (status === '10') {
                        this.setServe(auditInfo)
                    }
                    this.form = form
                }
                this.auditStatus = status
            },
            // 服务平台插入数据
            setServe(data) {
                let form = {
                    companyName: data.bName,
                    legalName: data.legalPerson,
                    legalIdCard: data.idcard,
                    busiCert: data.busiCert
                }
                 this.$common.post('/hdweb/portal/upgradeUser', form).then(res => {
                    if (res.data.code === 0) {
                        console.log(res)
                    }
                })
            }
        },
        computed: {
            // state user信息
            ...mapGetters({
                user: 'getUser',
                // city: 'getCity',
                cityArr: 'getCityArr'
            }),
            // 当前状态转换
            auditStatusText() {
                let auditText = ''
                switch (this.auditStatus) {
                    case '9': auditText = '待审核'; break
                    case '10': auditText = '通过'; break
                    case '99': auditText = '驳回'
                }
                return auditText
            }
        },
        watch: {
            // 城市变化
            cityArr(val) {
                this.cityObject = val[0]
            },
            // 监听路由
            '$route'(to) {
                // console.log(this)
                // console.log(to)
                if (to.path === '/') {
                    this.selectShow = true
                } else {
                    this.selectShow = false
                }
            }
        },
        created() {
            this.routerPath()
            this.getAuditStatus()
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/less/variable";
    /deep/ .status-btn{
        text-align: center;
        color: #000;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
    }
    #Index {
        width: 100%;
        min-width: 1200px;

        header {
            height: 100px;
            width: 100%;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 30px;
            box-sizing: border-box;
            .header-logo {
                img {
                    height: 46px;
                }

                select {
                    margin-left: 30px;
                    width: 55px;
                    height: 25px;
                    border: 1px solid rgba(204, 204, 204, 1);
                    border-radius: 2px;

                    &:focus {
                        outline: none;
                    }
                }
            }

            .header-login {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .search {
                    width: 180px;
                    height: 28px;
                    background: rgba(242, 242, 242, 1);
                    border-radius: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;

                    input {
                        height: 80%;
                        width: 60%;
                        border: none;
                        background: rgba(242, 242, 242, 1);
                    }

                    img {
                        height: 70%;
                    }
                }

                .header-login-content {
                    margin-left: 30px;
                    cursor: pointer;
                }

                .user {
                    margin-left: 30px;

                    a {
                        display: block;
                        color: black !important;
                    }

                    .user-info-link {
                        color: black !important;

                        a{
                            display: block;
                            color: black !important;
                        }
                    }

                    .header-box {
                        #header-box(34px, 34px)
                    }
                }
            }
        }

        nav {
            width: 100%;
            height: 100px;
            background: rgba(0, 0, 0, 0.3);
            position: relative;
            z-index: 4;
            .nav-box {
                width: 1200px;
                height: 100%;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                align-items: center;

                .nav-item {
                    margin-right: 70px;
                    color: white;
                    cursor: pointer;
                    font-size: 18px;
                    &.nav-active{
                        font-size: 24px;
                    }
                }
            }
        }

        .banner {
            width: 100%;
            min-width: 1200px;
            height: 500px;
            background: url("../assets/img/banner图.jpg") no-repeat;
            background-size: 100% 100%;

            .weather {
                width: 1200px;
                height: 100%;
                margin: 0 auto;
                color: white;
                font-size: 16px;

                .weather-box {
                    height: 100%;
                    width: 300px;
                    background: rgba(5, 160, 130, .9);
                    position: relative;

                    .weather-content {
                        width: 80%;
                        margin: 0 auto;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);

                        > h1 {
                            font-size: 48px;
                        }

                        > p {
                            margin-top: 15px;
                        }

                        .weather-info {
                            margin-top: 50px;
                            width: 100%;
                            display: flex;
                            justify-content: space-between;

                            > div {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                width: 33.3%;

                                > p {
                                    margin-bottom: 10px;
                                }

                                > img {
                                    width: 60%;
                                }
                            }
                        }
                    }
                }
            }
        }

        .index-content {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;

            .content-left {
                width: 65%;
                /*background: #42b983;*/

                .content-block {
                    .content-block-title {
                        margin-top: 30px;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        border-bottom: 2px solid rgba(5, 160, 130, 1);
                        padding-bottom: 5px;

                        > div {
                            width: 88%;

                            .tab-box {
                                margin: 5px 0;
                                width: 100%;
                                display: flex;
                                justify-content: flex-start;

                                > span {
                                    width: 80px;
                                }
                            }
                        }

                        > img {
                            margin: 0 5px;
                        }

                        > span {
                            font-size: 28px;
                            margin-right: 30px;
                        }
                    }

                    .item-block {
                        width: 100%;

                        .item-block-item {
                            margin: 30px 0;
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            .item-block-banner {
                                width: 35%;
                                height: 150px;
                                overflow: hidden;

                                img {
                                    width: 100%;
                                    height: 100%;
                                    transition: all .5s;

                                    &:hover {
                                        transform: scale(1.4);
                                    }
                                }
                            }

                            .item-block-info {
                                width: 62%;
                                height: 150px;

                                p:nth-of-type(1) {
                                    margin-top: 10px;
                                    font-size: 18px;
                                }

                                p:nth-of-type(2) {
                                    font-size: 12px;
                                    margin-top: 20px;
                                    color: rgba(102, 102, 102, 1);
                                    line-height: 18px;
                                    height: 36px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 2;
                                }

                                p:nth-of-type(3) {
                                    margin-top: 40px;
                                    font-size: 12px;
                                    color: rgba(153, 153, 153, 1);
                                }
                            }
                        }
                    }

                }
            }

            .content-right {
                width: 32%;
                /*background: #42b983;*/

                .code {
                    margin-top: 30px;

                    > p {
                        margin-top: 5px;
                        font-size: 12px;
                    }
                }

                .right-block {
                    margin-top: 30px;

                    .right-title {
                        img {
                            margin-right: 5px;
                        }

                        color: rgba(51, 51, 51, 1);
                        font-size: 18px;
                    }

                    .recommend {
                        margin: 30px 0;

                        .recommend-banner {
                            width: 100%;
                            height: 180px;
                            overflow: hidden;
                            display: flex;
                            align-items: center;

                            img {
                                width: 100%;
                                height: 100%;
                                transition: all .5s;

                                &:hover {
                                    transform: scale(1.4);
                                }
                            }
                        }

                        p {
                            margin: 10px 0 25px;
                            color: #222222;
                            height: 34px;
                            line-height: 17px;
                            overflow: hidden;
                        }
                    }

                    .commodity {
                        width: 100%;

                        .commodity-item {
                            margin: 15px 0;
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            .commodity-banner {
                                width: 35%;
                                height: 80px;
                                overflow: hidden;

                                img {
                                    width: 100%;
                                    height: 100%;
                                    transition: all .5s;

                                    &:hover {
                                        transform: scale(1.4);
                                    }
                                }
                            }

                            .commodity-info {
                                width: 62%;
                                height: 80px;

                                p:nth-of-type(1) {
                                    margin-top: 10px;
                                }

                                p:nth-of-type(2) {
                                    margin-top: 20px;
                                    color: #EB5541;
                                }
                            }
                        }
                    }
                }
            }
        }

        footer {
            width: 100%;
            min-width: 1200px;
            height: 140px;
            /*margin-top: 60px;*/
            background: rgba(51, 51, 51, 1);
            color: #999;

            > .footer-box {
                width: 1200px;
                margin: 0 auto;
                padding-top: 30px;
                box-sizing: border-box;

                .friendship {
                    display: flex;
                    justify-content: center;

                    > div {
                        margin-left: 20px;
                        cursor: pointer;

                        &:hover {
                            color: rgba(5, 160, 130, 1);
                        }

                        > span {
                            margin-left: 20px;
                        }
                    }

                }

                > p {
                    text-align: center;

                    &:nth-of-type(1) {
                        margin-top: 30px;
                    }

                    &:nth-of-type(2) {
                        margin-top: 10px;
                    }
                }
            }
        }

        .register-content {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 380px;
            height: 490px;
            background: rgba(255, 255, 255, 1);
            border-radius: 2px;

            input::-webkit-input-placeholder {
                color: #CCCCCC;
            }

            input::-moz-placeholder { /* Mozilla Firefox 19+ */
                color: #CCCCCC;
            }

            input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                color: #CCCCCC;
            }

            input:-ms-input-placeholder { /* Internet Explorer 10-11 */
                color: #CCCCCC;
            }

            > p {
                margin: 30px 0;
                text-align: center;
            }

            .input {
                margin: 0 auto;
                width: 300px;
                height: 50px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(204, 204, 204, 1);
                border-bottom: none;
                line-height: 50px;
                text-align: center;

                input {
                    width: 95%;
                    margin: 0 auto;
                    height: 25px;
                    border: none;
                }
            }

            .code-input {
                margin: 0 auto;
                width: 300px;
                height: 50px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(204, 204, 204, 1);
                line-height: 50px;
                /*text-align: center;*/

                > input {
                    /*padding-left: 2.5%;*/
                    width: 45%;
                    margin: 0 2.5%;
                    height: 25px;
                    border: none;
                }

                .code {
                    cursor: pointer;
                }

                /*.disable {*/

                /*}*/

                /*> span {*/
                /*    margin-right: ;*/
                /*}*/
            }
        }

        .button {
            margin: 30px auto 10px;
            width: 300px;
            height: 50px;
            background: rgba(5, 160, 130, 1);
            text-align: center;
            line-height: 50px;
            color: white;
        }

        .tip {
            margin: 0 auto;
            width: 300px;
            text-align: right;

            > span {
                cursor: pointer;
                color: #05A082;
            }
        }

        .login-content {
            height: 380px;

            .input {
                &:nth-of-type(2) {
                    border: 1px solid rgba(204, 204, 204, 1);
                    color: red;
                }
            }

            .tip {
                margin: 20px auto;
                width: 300px;
                text-align: right;

                > span {
                    cursor: pointer;
                    color: #999;
                }
            }
        }
    }
    .register-item {
        width: 50%;
        &:last-child,
        &:first-child{
            width: 100%;
        }
        display: inline-block;
        .slot-code {
            line-height: 40px;
            cursor: pointer;
            color: black;
        }
        .busi_cert{
            max-width: 100%;
        }
    }
   /deep/ .el-input.is-disabled .el-input__inner, /deep/ .el-textarea.is-disabled .el-textarea__inner {
       color: #606266;
    }
   /deep/ .el-dialog{
       margin-top: 0!important;
       overflow-y: auto;
       max-height: 86%;
       position: absolute;
       left: 50%;
       top: 50%;
       transform: translateX(-50%)translateY(-50%);
    }
   /deep/ .dialog-title{
       font-size: 18px;
       span{
           color: #EB5541;
           vertical-align: middle;
       }
    }
</style>



// WEBPACK FOOTER //
// src/views/Index.vue